import CryptoJSAES from 'crypto-js/aes';
import CryptoJSCore from 'crypto-js/core';

export function decryptTalkViewerPayload(payload: string, decryptKey: string) {
  const iv = CryptoJSCore.enc.Utf8.parse(decryptKey.substring(0, 16));
  const decodedKey = CryptoJSCore.enc.Utf8.parse(decryptKey);
  const decrypted = CryptoJSAES.decrypt(payload, decodedKey, {
    mode: CryptoJSCore.mode.CBC,
    iv,
  });
  return decrypted.toString(CryptoJSCore.enc.Utf8);
}
